(() => {
  if (window.__nvEngravingCartGuard) return;
  window.__nvEngravingCartGuard = true;

  let running = false;
  let scheduled = 0;

  const rootPath = () => window.Shopify?.routes?.root || '/';

  const fetchCart = async () => {
    const response = await fetch(rootPath() + 'cart.js', {headers:{Accept:'application/json'}});
    if (!response.ok) throw new Error('cart.js ' + response.status);
    return response.json();
  };

  const updateCart = async (updates) => {
    const response = await fetch(rootPath() + 'cart/update.js', {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({updates})
    });
    if (!response.ok) throw new Error('cart/update.js ' + response.status);
    return response.json();
  };

  const addItems = async (items) => {
    const response = await fetch(rootPath() + 'cart/add.js', {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({items})
    });
    if (!response.ok) throw new Error('cart/add.js ' + response.status);
    return response.json();
  };

  const reconcile = async () => {
    if (running) return;
    running = true;
    try {
      const cart = await fetchCart();
      const groups = new Map();

      for (const item of cart.items || []) {
        const props = item.properties || {};
        const bundleId = props._nv_bundle_id;
        if (!bundleId) continue;
        if (!groups.has(bundleId)) groups.set(bundleId, {base:null, services:[]});
        const group = groups.get(bundleId);
        if (props._nv_role === 'base') group.base = item;
        if (props._nv_role === 'service') group.services.push(item);
      }

      const updates = {};
      const additions = [];

      for (const [bundleId, group] of groups) {
        if (!group.base) {
          group.services.forEach((service) => { updates[service.key] = 0; });
          continue;
        }

        const base = group.base;
        const props = base.properties || {};
        const serviceVariant = Number(props._nv_service_variant || 0);
        let expected = [];
        try { expected = JSON.parse(props._nv_services || '[]'); } catch (_) { expected = []; }
        if (!Array.isArray(expected)) expected = [];

        const byIndex = new Map(
          group.services.map((service) => [Number(service.properties?._nv_service_index ?? -1), service])
        );

        expected.forEach((entry, index) => {
          const service = byIndex.get(index);
          if (!service && serviceVariant) {
            additions.push({
              id:serviceVariant,
              quantity:base.quantity,
              properties:{
                'Kapcsolódó termék': base.product_title || '',
                'Modell': entry.model || '',
                'Felirat': entry.text || '',
                '_nv_bundle_id': bundleId,
                '_nv_role': 'service',
                '_nv_service_index': String(index)
              }
            });
          } else if (service && service.quantity !== base.quantity) {
            updates[service.key] = base.quantity;
          }
        });

        group.services.forEach((service) => {
          const index = Number(service.properties?._nv_service_index ?? -1);
          if (index < 0 || index >= expected.length) updates[service.key] = 0;
        });
      }

      const hasUpdates = Object.keys(updates).length > 0;
      if (hasUpdates) await updateCart(updates);
      if (additions.length) await addItems(additions);

      if (hasUpdates || additions.length) {
        window.location.reload();
      }
    } catch (error) {
      console.warn('[NÓNIUSZ cart guard]', error);
    } finally {
      running = false;
    }
  };

  const schedule = (delay = 180) => {
    clearTimeout(scheduled);
    scheduled = setTimeout(reconcile, delay);
  };

  document.addEventListener('cart:update', () => schedule(220));
  document.addEventListener('change', (event) => {
    if (event.target.closest?.('.cart-items__quantity')) schedule(420);
  });
  document.addEventListener('click', (event) => {
    if (event.target.closest?.('.cart-items__remove')) schedule(420);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => schedule(80), {once:true});
  else schedule(80);
})();